import type { ListingDataTableColumn } from "../components/listing-data-table/listing-data-table-types";
import {
	EVENT_TYPE_UI,
	TRACKING_EVENTS_ALLOWED_TYPES,
} from "../events/events.config";
import type { EventListItem, EventTypeCode } from "../types/events";

export type { EventBadgeVariant } from "../events/events.config";
export {
	EVENT_BADGE_VARIANT_CLASSES,
	EVENT_TYPE_UI,
	TRACKING_EVENT_TYPE_SET,
	TRACKING_EVENTS_ALLOWED_TYPES,
	TRACKING_EVENTS_DEFAULT_QUERY_TYPES,
} from "../events/events.config";

const EVENT_TYPE_CODES_ALL = [
	1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13,
] as const satisfies readonly EventTypeCode[];

export const EVENT_TYPE_LABELS_PT = Object.fromEntries(
	EVENT_TYPE_CODES_ALL.map((code) => [code, EVENT_TYPE_UI[code].listTitle])
) as Record<EventTypeCode, string>;

export const EVENT_TYPE_BADGE_VARIANT = Object.fromEntries(
	EVENT_TYPE_CODES_ALL.map((code) => [code, EVENT_TYPE_UI[code].badgeVariant])
) as Record<
	EventTypeCode,
	(typeof EVENT_TYPE_UI)[EventTypeCode]["badgeVariant"]
>;

/** @deprecated Prefer `TRACKING_EVENTS_ALLOWED_TYPES` from `events.config`. */
export const FIGMA_TRACKING_EVENT_TYPES = TRACKING_EVENTS_ALLOWED_TYPES;

export const EVENT_TYPE_FILTER_OPTIONS: { id: EventTypeCode; label: string }[] =
	TRACKING_EVENTS_ALLOWED_TYPES.map((id) => ({
		id,
		label: EVENT_TYPE_UI[id].listTitle,
	}))
		.filter((option) => option.id !== 11)
		.sort((a, b) =>
			a.label.localeCompare(b.label, "pt-BR", {
				sensitivity: "accent",
			})
		);

export const EVENTS_TABLE_COLUMNS: ListingDataTableColumn<EventListItem>[] = [
	{
		id: "driver",
		label: "Motorista",
	},
	{ id: "eventType", label: "Evento" },
	{ id: "plate", label: "Placa" },
	{ id: "model", label: "Modelo" },
	{
		id: "start",
		label: "Data e hora",
	},
];
